export const HOME = '/';
export const SIGNIN = '/signin';
export const SIGNIN_NAVER = `${SIGNIN}/naver`;
export const SIGNIN_KAKAO = `${SIGNIN}/kakao`;
export const SIGNUP = '/signup';
export const SIGNUP_SNS = '/signup/sns';
export const FIND = '/find';
export const PASSWORD_RESET = '/password-reset';
export const SALES = '/service';
export const SALES_CLEARFACE = '/clearface';
export const ORDER = '/order';
export const ORDER_CLEARFACE = `${SALES_CLEARFACE}/order`;
export const ORDER_PRESENT = '/present';
export const ORDER_PRE_PURCHASE = '/pre-purchase';
export const COMPLETION = '/completion';
export const EVENT = '/event/intro';
export const EVENT_DETAIL = '/event-detail';
export const INFO = '/info';
export const INFO_PRIVACY = `${INFO}/privacy`;
export const INFO_TERM = `${INFO}/term`;
export const INFO_CANCEL = `${INFO}/cancel`;
export const MYPAGE = '/mypage';
export const MYPAGE_ORDER = `${MYPAGE}/order`;
export const MYPAGE_ORDER_DETAIL = `${MYPAGE_ORDER}/detail`;
export const MYPAGE_ORDER_RESULT = `${MYPAGE_ORDER}/result`;
export const MYPAGE_ORDER_REFUND = `${MYPAGE_ORDER}/refund`;
export const MYPAGE_VOUCHER_ORDER_DETAIL = `${MYPAGE}/voucher-order/detail`;
export const MYPAGE_VOUCHER = `${MYPAGE}/voucher-coupon`;
export const MYPAGE_REVIEW = `${MYPAGE}/reviewlist`;
export const MYPAGE_PAYBACK = `${MYPAGE}/payback`;
export const MYPAGE_ACCOUNT = `${MYPAGE}/account`;
export const MYPAGE_ACCOUNT_WITHDRAWAL = `${MYPAGE}/account/withdrawal`;
export const REVIEW = '/review';
export const REVIEW_DETAIL = `${REVIEW}/detail`;
export const REVIEW_WRITE = `${REVIEW}/write`;
export const REVIEW_REWRITE = `${REVIEW}/rewrite`;
export const BRAND_STORY = `/brand-story`;
export const BLOG = `/blog`;
export const HE = '/he';
export const HE_SIGNIN = `${HE}/signin`;
export const HE_SIGNUP = `${HE}/signup`;
export const HE_PRIVACY_CONSENT = `${HE}/privacy-consent`;
export const HE_RESULTS = `${HE}/results`;
export const HE_REVIEW_EVENT = `${HE}/review-event`;
export const HE_RECORDING = `${HE}/recording`;
export const HE_RECORDING_BARCODE = `${HE_RECORDING}/barcode`;
export const HE_RECORDING_PRIVACY_CONSENT = `${HE_RECORDING}/privacy-consent`;
export const HE_RECORDING_LIST = `${HE_RECORDING}/lists`;